import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import IndexPage from "../views/IndexPage.vue";
import UserLogin from "../views/UserLogin.vue";
import DashboardView from "../views/DashboardView.vue";
import UserRegistration from "../views/UserRegistration";
import RequestEmailVerification from "../views/E-Mail-Notification/ActivateMailAdressEmailVerification";
import VerifyAccountActivation from "../views/Verification_with_Token/VerifyAccountActivation";
import SearchCertificatesPage from "../views/Certificate/SearchCertificatesPage";
import ViewCaCertificates from "../views/Certificate/ViewCaCertificates";
import VerifyEmailAddress from "../views/Verification_with_Token/VerifyEmailAddress";
import PageNotFound from "../views/PageNotFound";
import ErrorPage from "../views/ErrorPage";
import ViewCertificateDetails from "../views/Certificate/ViewCertificateDetails";
import CreateCertificateWizard from "../views/Certificate/CreateCertificateWizard";

import CertificateType from "../enums/CertificateType";
import CertificateSource from "../enums/CertificateSource";

import VerifyPasswordReset from "../views/Verification_with_Token/VerifyPasswordReset";
import ForgotPassword from "../views/ForgotPassword";
import ResetPasswordEmailNotification from "../views/E-Mail-Notification/ResetPasswordEmailNotification";
import ChangePassword from "../views/ChangePassword";
import UserProfile from "../views/UserProfile";
import CreateCertificateWizardStep2Traditional from "../views/Certificate/CreateCertificateWizardStep2Traditional";
import CreateCertificateWizardStep1 from "../views/Certificate/CreateCertificateWizardStep1";
import CreateCertificateWizardStep2Pqc from "../views/Certificate/CreateCertificateWizardStep2Pqc";
import CreateCertificateWizardStep3FromCsr from "../views/Certificate/CreateCertificateWizardStep3FromCsr";
import CreateCertificateWizardStep3FromNewKeypair from "../views/Certificate/CreateCertificateWizardStep3FromNewKeypair";
import CreateCertificateWizardStep3FromExisting from "../views/Certificate/CreateCertificateWizardStep3FromExisting";
import CreateCertificateKeypairDownload from "../views/Certificate/CreateCertificateKeypairDownload";
import VerifyEmailUpdate from "../views/Verification_with_Token/VerifyEmailUpdate";
import TermsAndConditions from "../views/TermsAndConditions";
import QuantumSafeApps from "../views/QuantumSafeApps";
import QuantumSafeAppsInstructions from "../views/QuantumSafeAppsInstructions";
import HowToGuide from "../views/HowToGuide";
import Contact from "../views/Contact";
import CreateCertificateFromExisting from "../views/Certificate/CreateCertificateFromExisting";
import ActivateMailAddress from "@/views/ActivateMailAddress";
import RenewAdminCertificate from "@/views/RenewAdminCertificate"
Vue.use(VueRouter);

const routes = [
  /* Auth endpoints */
  {
    path: "/",
    name: "login-and-registration",
    meta: { layout: "login-and-registration", showToolbar: true },
    component: IndexPage
  },
  {
    path: "/login",
    name: "login",
    meta: { layout: "login-and-registration", showToolbar: false },
    component: UserLogin
  },
  {
    path: "/register",
    name: "register",
    meta: { layout: "login-and-registration", showToolbar: false },
    component: UserRegistration
  },
  {
    path: "/terms-conditions",
    name: "terms-conditions",
    meta: { layout: "login-and-registration", showToolbar: false },
    component: TermsAndConditions
  },
  {
    path: "/verify-registration",
    name: "verify-registration",
    meta: { layout: "login-and-registration", showToolbar: false },
    component: VerifyEmailAddress
  },
  {
    path: "/update-email",
    name: "update-email",
    meta: { layout: "login-and-registration", showToolbar: false },
    component: VerifyEmailUpdate
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    meta: { layout: "login-and-registration", showToolbar: false },
    component: ForgotPassword
  },
  {
    path: "/activate-MailAddress",
    name: "activate-MailAddress",
    meta: { layout: "login-and-registration", showToolbar: false },
    component: ActivateMailAddress
  },
  {
    path: "/reset-password",
    name: "reset-password-verification",
    meta: { layout: "login-and-registration", showToolbar: false },
    component: VerifyPasswordReset
  },
  {
    path: "/reset-password-email-notification",
    name: "reset-password-email-notification",
    meta: { layout: "login-and-registration", showToolbar: false },
    component: ResetPasswordEmailNotification
  },
  {
    path: "/change-password",
    name: "change-password",
    meta: { layout: "login-and-registration", showToolbar: false },
    component: ChangePassword
  },
  {
    path: "/email-verification",
    name: "email-verification",
    meta: { layout: "login-and-registration", showToolbar: false },
    component: RequestEmailVerification
  },

  {
    path: "/verify-emailAddress",
    name: "verify-emailAddress",
    meta: { layout: "login-and-registration", showToolbar: false },
    component: VerifyEmailAddress
  },
  {
    path: "/account-verification",
    name: "account-verification",
    meta: { layout: "page-not-found" },
    component: VerifyAccountActivation
  },
  {
    path: "/renew-SMIME",
    name: "renew-SMIME",
    meta: { layout: "page-not-found" },
    component: RenewAdminCertificate
  },
  /* Domain endpoints */
  {
    path: "/dashboard",
    name: "dashboard",
    meta: { requiresAuth: true },
    component: DashboardView
  },
  {
    path: "/certificates",
    name: "certificates",
    meta: { requiresAuth: true },
    component: SearchCertificatesPage
  },
  {
    path: "/ca-certificates",
    name: "ca-certificates",
    meta: { requiresAuth: true },
    component: ViewCaCertificates
  },
  {
    path: "/quantum-safe-apps",
    name: "quantum-safe-apps",
    meta: { requiresAuth: true },
    component: QuantumSafeApps
  },
  {
    path: "/quantum-safe-apps/instructions",
    name: "quantum-safe-apps-instructions",
    meta: { requiresAuth: true },
    component: QuantumSafeAppsInstructions
  },
  {
    path: "/user-profile",
    name: "user-profile",
    meta: { requiresAuth: true },
    component: UserProfile
  },
  {
    path: "/certificate-detail/:id",
    name: "certificate-detail",
    meta: { requiresAuth: true },
    component: ViewCertificateDetails
  },
  {
    path: "/how-to-guide",
    name: "how-to-guide",
    meta: { requiresAuth: true },
    component: HowToGuide
  },
  {
    path: "/contact",
    name: "contact",
    meta: { requiresAuth: true },
    component: Contact
  },
  {
    path: "/certificate/create",
    meta: { requiresAuth: true },
    component: CreateCertificateWizard,
    children: [
      {
        path: "",
        name: "certificate-create",
        meta: { currentStep: 1 },
        component: CreateCertificateWizardStep1
      },
      {
        path: "traditional",
        name: "certificate-create-traditional",
        meta: { currentStep: 2, type: CertificateType.TRADITIONAL },
        component: CreateCertificateWizardStep2Traditional
      },
      {
        path: "pqc",
        name: "certificate-create-pqc",
        meta: { currentStep: 2, type: CertificateType.PQC },
        component: CreateCertificateWizardStep2Pqc
      },
      {
        path: "traditional/from-csr",
        name: "certificate-create-traditional-from-csr",
        meta: { currentStep: 3, type: CertificateType.TRADITIONAL, source: CertificateSource.FROM_CSR },
        component: CreateCertificateWizardStep3FromCsr
      },
      {
        path: "traditional/from-new-keypair",
        name: "certificate-create-traditional-from-new-keypair",
        meta: { currentStep: 3, type: CertificateType.TRADITIONAL, source: CertificateSource.FROM_NEW_KEYPAIR },
        component: CreateCertificateWizardStep3FromNewKeypair
      },
      {
        path: "traditional/from-existing",
        name: "certificate-create-traditional-from-existing",
        meta: { currentStep: 3, type: CertificateType.TRADITIONAL, source: CertificateSource.FROM_EXISTING },
        component: CreateCertificateWizardStep3FromExisting
      },
      {
        path: "pqc/from-new-keypair",
        name: "certificate-create-pqc-from-new-keypair",
        meta: { currentStep: 3, type: CertificateType.PQC, source: CertificateSource.FROM_NEW_KEYPAIR },
        component: CreateCertificateWizardStep3FromNewKeypair
      },
      {
        path: "pqc/from-existing",
        name: "certificate-create-pqc-from-existing",
        meta: { currentStep: 3, type: CertificateType.PQC, source: CertificateSource.FROM_EXISTING },
        component: CreateCertificateWizardStep3FromExisting
      }
    ]
  },
  {
    path: "/certificate/:id/keypair",
    name: "certificate-keypair-download",
    meta: { requiresAuth: true },
    component: CreateCertificateKeypairDownload,
    props: true // Make sure to pass the { keypairFile, keypairPassword } as props
  },
  {
    path: "/certificate/:id/copy",
    name: "certificate-copy",
    meta: { requiresAuth: true },
    component: CreateCertificateFromExisting,
    props: true
  },
  {
    path: "/error",
    name: "error",
    meta: { layout: "page-not-found" },
    component: ErrorPage,
    props: true
  },
  { path: "*", meta: { layout: "page-not-found" }, component: PageNotFound }
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Scroll to top of the page with all route redirection when there is no savedposition
    const position = {
      x: 0,
      y: 0
    };

    // Override default with saved position (if it exists) - back and forward in browser tab
    if (savedPosition) {
      position.x = savedPosition.x;
      position.y = savedPosition.y;
    }
    // eslint-disable-next-line no-unused-vars
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(position);
      }, 1000);
    });
  }
});

router.beforeEach((to, from, next) => {
  const loggedIn = store.getters["auth/isLoggedIn"];

  // If not logged-in, but requires auth
  if (!loggedIn && to.matched.some(record => record.meta.requiresAuth)) {
    next({ name: "login-and-registration" });
    return;
  }

  // If logged-in, redirect login pages to the dashboard
  if (loggedIn && (to.name === "login" || to.name === "register" || to.name === "login-and-registration")) {
    next({ name: "dashboard" });
    return;
  }

  next();
});

export default router;
